import { Box, Typography } from "@mui/material";

import NotificationCardWrapper from "../NotificationCardWrapper";
import CustomAvatar from "../../CustomAvatar";

const NotificationPublish = ({ data, link }) => {
  const handleLink = () => {
    let conLink = null;
    if (link === "opinion") {
      conLink = `/table/${data?.target.pk}/opinions/${data?.action_object.pk}`;
    }
    if (link === "discussion") {
      conLink = `/table/${data?.target.pk}/discussions/${data?.action_object.pk}`;
    }
    if (link === "topic") {
      conLink = `/table/${data?.target.pk}/opinions/${data?.action_object.opinion?.pk}/topics/${data?.action_object?.pk}`;
    }
    return conLink;
  };

  return (
    <>
      {data?.action_object ? (
        <NotificationCardWrapper
          link={handleLink()}
          firstChild={
            <CustomAvatar
              size={48}
              src={data?.actor.avatar}
              alt={data?.actor.avatar}
              borderSize={1.5}
            />
          }
          seccondChild={
            <Box>
              <Typography
                sx={{ display: "inline-block", fontWeight: "600", mr: "4px" }}
              >
                {data?.actor.username}
              </Typography>
              <Typography sx={{ display: "inline-flex", mr: "4px" }}>
                published a new
                {" " + link + " "}
                in
              </Typography>

              <Typography sx={{ display: "inline-block", fontWeight: "600" }}>
                {data?.target.title}
              </Typography>
            </Box>
          }
          ThirdChild={
            <CustomAvatar
              size={48}
              src={data?.target.banner}
              alt={data?.target.banner}
              borderSize={1.5}
              round={"8px"}
            />
          }
        />
      ) : null}
    </>
  );
};

export default NotificationPublish;
